export const el = {
  // Landing
  fieldGuide: "§ Οδηγός AR",
  title: "Εμπειρία Επαυξημένης Πραγματικότητας στην",
  titleHighlight: "Πύλη Της Αμμοχώστου",
  landingDescription:
    "Ταξιδέψτε στην ιστορία της Porta Giuliana μέσα από μια εμπειρία Επαυξημένης Πραγματικότητας. Εξερευνήστε το μνημείο μέσα από το κινητό σας, ανακαλύψτε τις ιστορίες του και δείτε το παρελθόν να ζωντανεύει μέσα από τρισδιάστατα μοντέλα και ψηφιακές αναπαραστάσεις. Είστε έτοιμοι για το ταξίδι;",
  plateCaption: "Πίνακας I. — Ανατολική όψη, κατά Caoursin.",
  hotspots: "§ 12 σημεία",
  duration: "~ 25 λεπτά",
  beginWalk: "Ξεκινήστε την Εμπειρία",

  // Story
  theGate: "§ 01 · Η Πύλη",
  portaGiuliana: "Porta",
  giuliana: "Giuliana",
  gateSubtitle: "Η ανατολική πύλη των ενετικών τειχών της Λευκωσίας",
  storyP1:
    "Το 1567, καθώς η Οθωμανική Αυτοκρατορία έστρεφε το βλέμμα της δυτικά πέρα από τη Μεσόγειο, η Δημοκρατία της Βενετίας διέταξε την πλήρη ανακατασκευή των μεσαιωνικών οχυρώσεων της Λευκωσίας. Ο στρατιωτικός μηχανικός Giulio Savorgnan σχεδίασε έναν περίβολο έντεκα προμαχώνων — έναν δακτύλιο γωνιακών τειχών σχεδιασμένων να απορροφούν τα πυρά κανονιών.",
  storyP2:
    "Τρεις πύλες διαπερνούσαν τα νέα τείχη: η Πάφου στα δυτικά, η Κερύνειας στα βόρεια, και αυτή — η Porta Giuliana, η Πύλη Αμμοχώστου — στα ανατολικά, με θέα τον δρόμο προς το κύριο λιμάνι του νησιού.",

  // AR Prompt
  arExperience: "§ Εμπειρία AR",
  readyTo: "Έτοιμοι να",
  explore: "εξερευνήσετε;",
  arDescription:
    "Στρέψτε την κάμερά σας στην πύλη για να ανακαλύψετε τις κρυμμένες ιστορίες της. Αναζητήστε τους ειδικούς δείκτες για να ξεκλειδώσετε ιστορικές λεπτομέρειες.",
  enableCamera: "Ενεργοποίηση κάμερας",
  beforeYouBegin: "Πριν ξεκινήσετε",
  tipVolume:
    "Ανεβάστε την ένταση του τηλεφώνου σας για να ακούσετε καθαρά την αφήγηση.",
  tipCamera:
    "Επιτρέψτε την πρόσβαση στην κάμερα και τους αισθητήρες κίνησης. Απαιτείται για την εμπειρία AR.",
  requestingAccess: "Αίτημα πρόσβασης...",
  redirectingToExperience: "Είσοδος στην εμπειρία...",
  cameraReady: "Κάμερα έτοιμη",
  cameraReadyDesc: "Η εμπειρία AR είναι έτοιμη να ξεκινήσει.",
  startExploring: "Ξεκινήστε την εξερεύνηση",
  cameraDenied: "Η άδεια απορρίφθηκε",
  cameraDeniedDesc:
    "Παρακαλώ ενεργοποιήστε την πρόσβαση στην κάμερα και την κίνηση στις ρυθμίσεις του προγράμματος περιήγησης ή της συσκευής σας, στη συνέχεια επιστρέψτε εδώ.",
  tryAgain: "Το ενεργοποίησα",

  // Time restriction
  afterHours: "Η πύλη αναπαύεται",
  afterHoursDesc:
    "Αυτή η εμπειρία είναι διαθέσιμη μεταξύ 7 π.μ. και 7 μ.μ., όταν το φως της ημέρας φωτίζει τη λιθοδομή και οι σκιές αποκαλύπτουν τις λεπτομέρειες που οι αιώνες έχουν χαράξει στα τείχη. Επιστρέψτε όταν ο ήλιος είναι ψηλά.",

  // Desktop
  desktopNotice: "§ ΕΜΠΕΙΡΙΑ ΣΤΟΝ ΧΩΡΟ ΜΕΣΩ ΚΙΝΗΤΟΥ",
  aboutTitle: "Σχετικά",
  termsTitle: "Όροι",
  creditsTitle: "Συντελεστές",
  pageTitle: "Πύλη Αμμοχώστου",
  desktopTitle: "Εμπειρία Επαυξημένης Πραγματικότητας στην Porta Giuliana",
  desktopDescription:
    "Το AREXPG είναι ένας οδηγός επαυξημένης πραγματικότητας για την Porta Giuliana, την ανατολικότερη πύλη των ενετικών τειχών της Λευκωσίας. \n Η εμπειρία χρησιμοποιεί την κάμερα, την πυξίδα, τον προσανατολισμό και την τοποθεσία του τηλεφώνου ενώ ο επισκέπτης βρίσκεται φυσικά στην πύλη. Για αυτόν τον λόγο, δεν είναι δυνατή η πρόσβαση από επιτραπέζιο υπολογιστή.",
  desktopNote:
    "Για να ξεκινήσετε, ανοίξτε αυτή τη σελίδα σε κινητή συσκευή ενώ βρίσκεστε στην Porta Giuliana. Η εμπειρία είναι διαθέσιμη μεταξύ αυγής και σούρουπου.",
  scanWithPhone: "Σαρώστε με το τηλέφωνό σας",
  plateI: "Πίνακας I. — Πύλη Αμμοχώστου, ανατολική όψη.",
  mobileOnly: "Μόνο κινητό",

  // Menu
  language: "Γλώσσα",

  // Footer
  about: "Σχετικά",
  terms: "Όροι",
  credits: "Συντελεστές",
  back: "Πίσω",

  // Image and control labels

  // Markdown pages
  loading: "Φόρτωση...",
  error: "Σφάλμα",
  loadFailed: "Η φόρτωση του περιεχομένου απέτυχε.",

  // Cookie banner
  cookieTitle: "Cookies",
  cookieText:
    "Χρησιμοποιούμε cookies του Google Analytics για να κατανοήσουμε πώς χρησιμοποιείται η εμπειρία και να τη βελτιώσουμε. Ενεργοποιούνται μόνο αν τα αποδεχτείτε.",
  cookieAccept: "Αποδοχή",
  cookieDecline: "Απόρριψη",
  cookieSettings: "Ρυθμίσεις cookies",
};
